import React, { useEffect, useState } from "react";
import classes from './Card.module.css';

import IPIOCC_Icon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Online.svg"

const Card = (props, { key }) => {

    return (
        <div key={key || null} style={{display:"flex", flexDirection:"column", backgroundColor:"#ffffff", borderRadius:"12px", color:"#8e8e8e",
             boxShadow: "0 0 4px rgba(0, 0, 0, 0.15)", padding:"10px", maxWidth:"400px"}} onClick={props.onClick}>
            {props.children}
        </div>
    );
}

export default Card;
